import { Strategy as StrategyType, VIDEO_TACTICS } from '../utils'
import Styles from './CustomizeTable.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { Video } from 'blaze-ui/icons/24'
import { Trash2 } from 'blaze-ui/icons/20'
import { StrategyVideoDropdown } from '../StrategyVideoDropdown'
import { CountInput } from 'components/Wizards/CountInput/CountInput'
import cx from 'classnames'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { useHover } from '@react-aria/interactions'
import { BrandPlanTactic } from 'types'
import { uniq } from 'lodash'

export interface VideosRowProps {
  strategy: StrategyType
  onUpdate: (strategy: StrategyType) => void
  isDisabled?: boolean
}

export const VideosRow = ({ strategy, onUpdate, isDisabled }: VideosRowProps) => {
  const { hoverProps, isHovered } = useHover({})

  const videoCrosspostContentsCount =
    strategy.video_crosspost_contents.find((content) => content.type === 'post')?.count || 0

  const handleUpdate = (value: number) => {
    let newTactics: BrandPlanTactic[] = strategy.tactics
    if (value === 0) {
      newTactics = newTactics.filter((tactic) => !VIDEO_TACTICS.includes(tactic))
    } else if (value === 1 && !newTactics.some((tactic) => VIDEO_TACTICS.includes(tactic))) {
      newTactics = uniq([...newTactics, ...VIDEO_TACTICS])
    }

    onUpdate({
      ...strategy,
      video_crosspost_contents: [{ type: 'post', count: value }],
      tactics: newTactics,
    })
  }

  return (
    <div className={Styles.customizeContentRow} {...hoverProps}>
      <div className={Styles.customizeContentRowItem}>
        <Video size={20} color="#6A00FF" />
        <Text>Video</Text>
      </div>
      <div className={cx(Styles.customizeContentRowItem, Styles.settingRowItem)}>
        <StrategyVideoDropdown strategy={strategy} onUpdate={onUpdate} isDisabled={videoCrosspostContentsCount === 0} />
      </div>
      <div className={cx(Styles.customizeContentRowItem, Styles.settingRowItem)}>
        <CountInput
          name="video_crosspost_contents"
          value={videoCrosspostContentsCount || 0}
          onChange={handleUpdate}
          min={isDisabled ? 1 : 0}
          size="sm"
          buttonSize="sm"
          className={Styles.countInput}
        />
      </div>
      <div
        className={cx(Styles.customizeContentRowItem, Styles.actionRowItem, {
          [Styles.visible]: isHovered && videoCrosspostContentsCount > 0,
        })}
      >
        <IconButton icon={Trash2} variant="tertiary" onPress={() => handleUpdate(0)} isDisabled={isDisabled} />
      </div>
    </div>
  )
}
